document.addEventListener('DOMContentLoaded', function () {
    var galleries = document.querySelectorAll('media-gallery[data-product-variants]');

    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
        var productFormId = gallery.dataset.productFormId || '';
        var form =
            document.getElementById(productFormId) ||
            document.querySelector('form[id="' + productFormId + '"]') ||
            document.querySelector('form[action*="/cart/add"]');

        if (!form) return;

        var productVariants = [];
        var productMedia = [];
        var mainProductMediaId = gallery.dataset.mainProductMediaId || '';

        try {
            productVariants = JSON.parse(gallery.dataset.productVariants || '[]');
        } catch (error) {
            console.error('[gallery] erreur parsing productVariants', error);
            productVariants = [];
        }

        try {
            productMedia = JSON.parse(gallery.dataset.productMedia || '[]');
        } catch (error) {
            console.error('[gallery] erreur parsing productMedia', error);
            productMedia = [];
        }

        var variantIdInput = form.querySelector('input[name="id"]');
        var hasUserInteracted = false;
        var lastKnownVariantId = variantIdInput && variantIdInput.value ? String(variantIdInput.value) : '';
        var watcherId = null;

        function getVariantById(variantId) {
            if (!variantId) return null;

            for (var i = 0; i < productVariants.length; i++) {
                if (String(productVariants[i].id) === String(variantId)) {
                    return productVariants[i];
                }
            }

            return null;
        }

        function getVariantMediaId(variant) {
            if (!variant) return null;

            if (variant.featured_media && variant.featured_media.id) {
                return String(variant.featured_media.id);
            }

            if (variant.featured_image) {
                if (variant.featured_image.id) {
                    return String(variant.featured_image.id);
                }

                var variantImageSrc = variant.featured_image.src || variant.featured_image.url;

                if (variantImageSrc) {
                    variantImageSrc = String(variantImageSrc);

                    for (var i = 0; i < productMedia.length; i++) {
                        var media = productMedia[i];
                        if (!media) continue;

                        var mediaSrc = media.src || (media.preview_image && media.preview_image.src) || '';
                        if (!mediaSrc) continue;

                        mediaSrc = String(mediaSrc);

                        if (
                            mediaSrc.indexOf(variantImageSrc) !== -1 ||
                            variantImageSrc.indexOf(mediaSrc) !== -1
                        ) {
                            return String(media.id);
                        }
                    }
                }
            }

            return null;
        }

        function getThumbnailByMediaId(mediaId) {
            if (!mediaId) return null;

            return gallery.querySelector(
                '[data-thumbnail-media-id="' + mediaId + '"], ' +
                '.product__thumbnail[data-media-id="' + mediaId + '"], ' +
                '[data-media-id="' + mediaId + '"].product__thumbnail'
            );
        }

        function activateThumbnailByMediaId(mediaId) {
            if (!mediaId) return false;

            var thumb = getThumbnailByMediaId(mediaId);

            if (!thumb) {
                console.log('[gallery] thumbnail introuvable pour mediaId =', mediaId);
                return false;
            }

            try {
                if (typeof PointerEvent === 'function') {
                    thumb.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
                }
            } catch (e) {}

            try {
                thumb.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                thumb.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
                thumb.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                }));
            } catch (e) {}

            if (typeof thumb.click === 'function') {
                thumb.click();
            }

            console.log('[gallery] thumbnail activée pour mediaId =', mediaId, thumb);
            return true;
        }

        function buildPlaceholderHtml() {
            var template = gallery.querySelector('#product-placeholder');
            if (!template) return '';

            return (
                '<div class="product__media media flex w-full relative overflow-hidden" data-media-type="image" data-media-id="placeholder">' +
                template.innerHTML +
                '</div>'
            );
        }

        function showPlaceholder() {
            var placeholderHtml = buildPlaceholderHtml();
            if (!placeholderHtml) return;

            var mediaContainer = gallery.querySelector('.product__media-list');
            if (mediaContainer) {
                mediaContainer.innerHTML = placeholderHtml;
            }

            var stickyPreview = gallery.querySelector('sticky-element .product__media');
            if (stickyPreview) {
                stickyPreview.outerHTML = placeholderHtml;
            }

            var thumbnails = gallery.querySelector('.product__thumbnails, media-dots, .product__thumbnails-list');
            if (thumbnails) {
                thumbnails.style.display = 'none';
            }

            console.log('[gallery] placeholder affiché');
        }

        function showMainProductImage() {
            if (!mainProductMediaId) {
                showPlaceholder();
                return;
            }

            var ok = activateThumbnailByMediaId(String(mainProductMediaId));

            if (!ok) {
                showPlaceholder();
            }
        }

        function updateImageFromCurrentVariant() {
            if (!variantIdInput || !variantIdInput.value) return;

            var currentVariantId = String(variantIdInput.value);
            var selectedVariant = getVariantById(currentVariantId);
            var mediaId = getVariantMediaId(selectedVariant);

            console.log('[gallery] selectedVariant =', selectedVariant);
            console.log('[gallery] mediaId =', mediaId);

            if (mediaId) {
                var ok = activateThumbnailByMediaId(mediaId);
                if (ok) return;
            }

            if (mainProductMediaId) {
                showMainProductImage();
            } else {
                showPlaceholder();
            }
        }

        function markUserInteraction(event) {
            var target = event.target;
            if (!target) return;

            if (
                target.matches('select') ||
                target.matches('input[type="radio"]') ||
                target.matches('input[type="button"]') ||
                target.matches('input[type="checkbox"]') ||
                target.matches('[name^="options"]') ||
                target.closest('variant-selects') ||
                target.closest('variant-radios') ||
                target.closest('[data-variant-option]') ||
                target.closest('[data-option-value]')
            ) {
                hasUserInteracted = true;
                console.log('[gallery] interaction variant détectée');
            }
        }

        function startVariantWatcher() {
            if (watcherId) {
                window.clearInterval(watcherId);
            }

            watcherId = window.setInterval(function () {
                if (!variantIdInput) {
                    variantIdInput = form.querySelector('input[name="id"]');
                    if (!variantIdInput) return;
                }

                var currentVariantId = variantIdInput.value ? String(variantIdInput.value) : '';

                if (currentVariantId !== lastKnownVariantId) {
                    console.log('[gallery] variant id changé :', lastKnownVariantId, '->', currentVariantId);
                    lastKnownVariantId = currentVariantId;

                    if (hasUserInteracted) {
                        updateImageFromCurrentVariant();
                    }
                }
            }, 150);
        }

        showMainProductImage();

        form.addEventListener('change', markUserInteraction, true);
        form.addEventListener('input', markUserInteraction, true);
        form.addEventListener('click', markUserInteraction, true);

        document.addEventListener('change', markUserInteraction, true);
        document.addEventListener('click', markUserInteraction, true);

        startVariantWatcher();
    });
});
